import React, { useRef } from "react"
import Button from "@src/components/core-button"
import Spinner from "@src/components/core-spinner"
import { UserContext } from "@src/context/user-context"
import FormInput from "../../reusable/forms/form-input"
import { useForm, FormProvider } from "react-hook-form"
import {
  validateEmail,
  isAtLeast8Chars,
  hasNumber,
  hasSymbol,
  hasUpperCase,
  hasLowerCase,
} from "@src/utils/validators"
import { FormActions } from "../../reusable/forms/auth-forms.styled"
import Image from "../../core-image"

function FormResetPassword({ status, setStatus, switchToLogin, children }) {
  const methods = useForm()
  const formRef = useRef()

  const handleProgrammaticSubmit = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true }),
      )
    }
  }

  const validateSixDigits = value => {
    const sixDigitsPattern = /^\d{6}$/
    return sixDigitsPattern.test(value) || "Must contain exactly 6 digits"
  }

  const passwordValidators = value => {
    let error = false
    let string = ""

    const messages = [
      "Must be at least 8 characters",
      "Must include a number",
      "Must include a symbol (!@#$%^&*()-_+=)",
      "Must include an uppercase letter",
      "Must include a lowercase letter",
    ]
    let index = 0

    for (let validation of [
      isAtLeast8Chars,
      hasNumber,
      hasSymbol,
      hasUpperCase,
      hasLowerCase,
    ]) {
      const result = validation(value)

      if (result !== true) {
        error = true
        string += `<span> <div class="icon-close" ></div> ${messages[index]}</span> `
      } else {
        string += `<span> <div class="icon-check" ></div> ${messages[index]}</span> `
      }

      index++
    }

    return error ? string : true
  }

  return status.success ? (
    <>
      <p className="h2">{`You're all set!`}</p>
      <p className="center">
        Your password has been reset. Let all the adventures begin!
      </p>
      <Image src="/images/user-flow-all-set.svg" className="center" />
      <Button
        variant="rounded"
        type="submit"
        className="center"
        onClick={switchToLogin}
      >
        Go to login
      </Button>
    </>
  ) : (
    <FormProvider {...methods}>
      <p className="h2 reset">Set new password</p>

      <p className="center">{`Password has been reset!`}</p>

      <UserContext.Consumer>
        {({ recoverPassword }) => {
          const handleSubmit = ({ email, code, password }) => {
            setStatus({ ...status, pending: true })
            recoverPassword(email, code, password)
              .then(() => {
                setStatus({
                  success: true,
                  pending: false,
                  formMessage: null,
                })
              })
              .catch(error => {
                setStatus({
                  success: false,
                  pending: false,
                  formMessage: error,
                })
              })
          }
          return (
            <>
              {status.success ? null : (
                <form
                  ref={formRef}
                  onSubmit={methods.handleSubmit(handleSubmit)}
                >
                  <FormInput
                    label="Email"
                    name="email"
                    type="email"
                    validate={validateEmail()}
                  />
                  <FormInput
                    label="Verification Code"
                    placeholder="Enter 6-digit password reset code"
                    name="code"
                    type="text"
                    validate={validateSixDigits}
                  />
                  <FormInput
                    label="Confirm Password"
                    name="password"
                    type="password"
                    validate={passwordValidators}
                  />
                </form>
              )}
              <FormActions>
                {status.formMessage && (
                  <p className="form-error">{status.formMessage}</p>
                )}
                <Button
                  variant="rounded"
                  type="submit"
                  disabled={status.pending}
                  onClick={handleProgrammaticSubmit}
                >
                  Reset password{" "}
                  {status.pending && <Spinner color="white" size="sm" />}
                </Button>
                {children}
              </FormActions>
            </>
          )
        }}
      </UserContext.Consumer>
    </FormProvider>
  )
}

export default FormResetPassword
